import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from '../../../core/http/api.service'
import { ApiCore } from 'src/app/config/api';
import { I18nService } from 'src/app/shared/services/i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { ITermsAndConditions } from '../../../models/Auth/AuthInterfaces';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.css']
})
export class TermsConditionsComponent implements OnInit {

  public title = ''
  public TerminosCondiciones: string = ''
  @Input() DisplaySideBar: boolean = false;
  @Output() onCloseSideBar = new EventEmitter<boolean>();
  constructor(private api: ApiService,private i18nService: I18nService,private translate: TranslateService) { }

  ngOnInit(): void {
    this.i18nService.localeEvent.subscribe({
      next: () => { this.useTranslate()}
    })
    this.api.get(`${ApiCore.CATALOGS}terms-and-conditions-catalog`,'')
      .subscribe((resp: ITermsAndConditions)=>{

        if(resp.statusCode !== 200){
          return;
        }
        if(!resp.data[0])
          return;

        const data = resp.data[0];
        this.title = data.name;
        this.TerminosCondiciones = data.description;
      },(error) =>console.error(error));

  }

  public useTranslate() {
    this.translate.use(this.i18nService.getLanguage());
  }

  public CloseTerm(){
    this.onCloseSideBar.emit(false)
  }

}
